import { useEffect, useState } from "react";

const useTimer = (seconds: number) => {
  const [value, setValue] = useState<number>(seconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setValue((o) => (o > 0 ? o - 1 : 0));
    }, 1_000);

    return () => clearInterval(interval);
  }, []);

  const resetTimer = () => setValue(seconds);

  return { timer: value, timerHasEnded: value === 0, resetTimer };
};

export default useTimer;
